module.exports = __webpack_public_path__ + "a4409393e55ce05979c31c338b361ce3.png";